import initAnchorLinks from "./elements/anchor-links";
import initWordAnchors from "./elements/word-anchors";
import initHeader from "./layout/header";
import initLargeSplitBlock from "./blocks/large-split";
import initSplitBlock from "./blocks/split";
import initContactBlock from "./blocks/contact";
import initCookieConsent from "./layout/cookie-consent";
import initPostList from "./layout/post-list";
import initFaqCategory from "./layout/taxonomy-faq-category";
import initGlossaryHeader from "./layout/glossary-header";
import initDropdown from "./elements/dropdown";
import initNewsletterCta from "./elements/newsletter-cta";
import initLegalQuestionBlock from "./blocks/legal-question";
import initFindLawyerBlock from "./blocks/find-lawyer";
import initMyAccountQuestions from "./layout/my-account/questions";
import initWysiwygContent from "./wysiwyg/wysiwyg-content";


initAnchorLinks();
initDropdown();
initWordAnchors();
initHeader();
initLargeSplitBlock();
initSplitBlock();
initContactBlock();
initCookieConsent();
initPostList();
initFaqCategory();
initGlossaryHeader();
initNewsletterCta();
initLegalQuestionBlock();
initFindLawyerBlock();
initMyAccountQuestions();
initWysiwygContent();
